export default __webpack_public_path__ + "5b43ac8021b3054f29f789ea3fe20ffe.jpg";